import BigInt from 'big-integer';
import { PrivateKey } from 'starkbank-ecdsa';
import { secp256k1 } from 'starkbank-ecdsa/ellipticcurve/curve';
import type { PrivateKey as IPrivateKey } from 'starkbank-ecdsa';
import { sign, constructAuthMessage, getCurrentTimestamp, signatureToBase64 } from '../../../shared/lib/crypto';
import { acceptLanguage } from '@/shared/lib/accept-language';

/**
 * Creates a session private key from a session secret (BigInt)
 * This is used for password reset sessions that come from email magic links
 */
export function createResetSessionPrivateKey(sessionSecret: string): IPrivateKey {
  // Convert session_secret string to BigInt
  const secretBigInt = BigInt(sessionSecret);
  
  // Create a PrivateKey from the secret using secp256k1 curve
  const privateKey = new PrivateKey(secp256k1, secretBigInt as any);
  
  return privateKey;
}

/**
 * Creates authentication headers for a reset session
 */
export async function createResetSessionAuthHeaders(
  sessionId: string,
  sessionPrivateKey: IPrivateKey,
  body?: any
): Promise<Record<string, string>> {
  const currentTime = getCurrentTimestamp();
  const message = constructAuthMessage(sessionId, currentTime, body);
  const signature = sign(sessionPrivateKey, message);
  
  // Convert signature to base64 format
  const signatureBase64 = signatureToBase64(signature);

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Access-Time': currentTime,
    'User-Id': sessionId,
    'User-Type': 'session',
    'Access-Signature': signatureBase64,
    'Accept-Language': acceptLanguage(),
  };

  return headers;
}

